import React, { useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { getUser } from "../../services/authService";
import { getCountryList } from "../../services/dataService";
import { createDailyPlan_AB } from "../../services/tractorDataService";
import AsyncSelectField from "./inputs/AsyncSelectField";

function CreateNewSchedule({ show, handleClose }) {
  const [shipmentData, setShipmentData] = useState({
    date: "",
    market: "",
    country: "",
    varient_PartNumber: "",
    type: "",
    category: "",
    quantity: 0,
    container_Count: 0,
    container_Type: "",
    containerId: 0,
    si: "",
    remark: "",
    created_By: getUser().uid,
  });
  const [loading, setLoading] = useState(false);
  const [value,setvalue] = useState("") 

  const handleTextChange = (e) => {
    setShipmentData({ ...shipmentData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await createDailyPlan_AB([shipmentData]);
      setLoading(false);
      handleClose();
      toast.success("New schedule created successfully");
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 400) {
        toast.error("Please check provided data and try again");
      }
    }
  };

  return (
    <>
      <Modal show={show} backdrop="static" onHide={handleClose} centered>
        <Modal.Body>
          <h4>Create new schedule</h4>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>Part number</Form.Label>
                <Form.Control
                  name="varient_PartNumber"
                  value={shipmentData.varient_PartNumber}
                  onChange={handleTextChange}
                  placeholder="enter vaient no"
                  required
                />
              </Form.Group>

              <Form.Group as={Col} md="5" className="mb-3">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  name="date"
                  value={shipmentData.date}
                  onChange={handleTextChange}
                  type="date"
                  required
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>Category</Form.Label>
                <Form.Control
                  name="category"
                  value={shipmentData.category}
                  onChange={handleTextChange}
                  placeholder="enter category"
                  required
                />
              </Form.Group>

              <Form.Group as={Col} className="mb-3">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  name="type"
                  value={shipmentData.type}
                  onChange={handleTextChange}
                  placeholder="enter type"
                  required
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>Market</Form.Label>
                <Form.Control
                  name="market"
                  value={shipmentData.market}
                  onChange={handleTextChange}
                  placeholder="enter market"
                  required
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>Country</Form.Label>
                <AsyncSelectField
                  dbKey={"Countryname"}
                  lableKey={"Countryname"}
                  value={{ Countryname: shipmentData.country }}
                  onChange={(option) => setShipmentData({ ...shipmentData, country: option.Countryname })}
                  getOptionsAPI={getCountryList}
                  setvalue={setvalue}
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>Quantity</Form.Label>
                <Form.Control
                  name="quantity"
                  type="number"
                  value={shipmentData.quantity}
                  onChange={handleTextChange}
                  placeholder="enter quantity"
                  required
                />
              </Form.Group>

              <Form.Group as={Col} className="mb-3">
                <Form.Label>Container type</Form.Label>
                <Form.Control
                  name="container_Type"
                  value={shipmentData.container_Type}
                  onChange={handleTextChange}
                  placeholder="enter container type"
                  required
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>SI</Form.Label>
                <Form.Control
                  name="si"
                  value={shipmentData.si}
                  onChange={handleTextChange}
                  placeholder="enter si"
                  required
                />
              </Form.Group>

              <Form.Group as={Col} className="mb-3">
                <Form.Label>Container count</Form.Label>
                <Form.Control
                  name="container_Count"
                  type="number"
                  value={shipmentData.container_Count}
                  onChange={handleTextChange}
                  placeholder="enter count"
                  required
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  name="remark"
                  value={shipmentData.remark}
                  onChange={handleTextChange}
                  placeholder="enter remark"
                  required
                />
              </Form.Group>
            </Row>
            <Button className="fr" type="submit" disabled={loading}>
              {loading ? "Creating" : "Create"}
            </Button>
            <Button
              className="fr  mr-1"
              variant="outline-primary"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CreateNewSchedule;
